"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    if (!element.value || !element.value.show) {
        return '';
    }
    const { info, success, fail } = element.value;
    const sections = [];
    if (info) {
        const infoText = (0, rich_text_1.slateToMarkdown)(info, {
            allowHtmlStyles: context.withStyle,
            allowAlignment: context.withStyle,
            allowCaptionHtml: context.withStyle,
        }).trim();
        if (infoText) {
            sections.push(`**Info:** ${infoText}`);
        }
    }
    if (success) {
        const successText = (0, rich_text_1.slateToMarkdown)(success, {
            allowHtmlStyles: context.withStyle,
            allowAlignment: context.withStyle,
            allowCaptionHtml: context.withStyle,
        }).trim();
        if (successText) {
            sections.push(`**Correct:** ${successText}`);
        }
    }
    if (fail) {
        const failText = (0, rich_text_1.slateToMarkdown)(fail, {
            allowHtmlStyles: context.withStyle,
            allowAlignment: context.withStyle,
            allowCaptionHtml: context.withStyle,
        }).trim();
        if (failText) {
            sections.push(`**Incorrect:** ${failText}`);
        }
    }
    if (sections.length === 0) {
        return '';
    }
    return sections.join('\n\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
